import React, { Dispatch, SetStateAction } from 'react';
import {
    Sortable as KendoSortable,
    SortableOnDragOverEvent,
    SortableOnNavigateEvent,
    SortableProps as KendoSortableProps,
} from '@progress/kendo-react-sortable';

interface SortableProps<T extends object> extends KendoSortableProps {
    data: T[];
    setData: Dispatch<SetStateAction<T[]>>;
}

const Sortable = <T extends object>({ data, setData, ...rest }: SortableProps<T>) => {
    const onDragOver = (event: SortableOnDragOverEvent) => {
        setData(event.newState as T[]);
    };

    const onNavigate = (event: SortableOnNavigateEvent) => {
        setData(event.newState as T[]);
    };

    return <KendoSortable data={data} onDragOver={onDragOver} onNavigate={onNavigate} {...rest} />;
};

export default Sortable;
